import {getCurrentInstance} from 'vue'
import { useStorage } from "@vueuse/core";
const common = {
	/**
	 * H5存储参数
	 */
	saveStorage:(name,params)=>{
		localStorage.setItem(name,JSON.stringify(params))
	},
	/**
	 * H5取查询条件
	 */
	initStorage:(route,callBack)=>{
		let name = route.name
		let init = route.query.init
		if(typeof init != 'undefined'&&init==1){
			localStorage.removeItem(name)
		}else{
			callBack(JSON.parse(localStorage.getItem(name)))
		}
	},
	/**
	 * 获取权限问题
	 */
	getAuths:async(proxy)=>{
		//从缓存获取权限
		// let listAuths = useStorage("listAuths");
		// if(listAuths==null||listAuths==''){
			//重新初始化权限
		// }
		if(typeof(proxy) == 'undefined'){
			proxy = getCurrentInstance().proxy
		}

		let author = await	proxy.$store.dispatch('getAuthor')
		return author
		// const res = await new proxy.$request(proxy.$urls.m().sysUser_getSessionUser,{}).modepost()
		// if(res.status == 200){
		// 	let listAuths = res.data.data.listAuths;
		// 	let authOBbj = {}
		// 	for(let i=0;i<listAuths.length;i++){
		// 		authOBbj["auth_"+listAuths[i]]=true
		// 	}
		// 	console.log("authOBbj:",authOBbj);
		// 	return authOBbj
		// }
	},
	/**
	 * 返回上一级
	 * @param {*} router  路由
	 * @param {*} toPath  返回路径 如果有back，则返回上一级，去掉init=1条件
	 */
	goBack:async(router,toPath)=>{
		let back = router.options.history.state.back;
		if(back!=null){
			back = back.replace("init=1","");
			router.push({
				path:back
			})
		}else{
			router.push({
				path:toPath
			})
		}
	},
	/**
	 * 后台获取帮助标识是否需要显示
	 * pageId: 页面ID
	 * callBack: 回调方法 参数（data）是否有值
	 * 
	 * 例如：页面中，可以写在 onMounted 方法中
	 * 		proxy.$common.getHelpFlag("sealInfor",(data)=>{
	 *				tourOpen.value = !data
	 	 *		})
	 */
	getHelpFlag:async(pageId,callBack)=>{
		//从缓存获取权限
		let help_flag = useStorage("help_flag_"+pageId);
		if(help_flag.value!=null&&typeof help_flag.value!="undefined"){
			callBack(true)
		}else{
			const {proxy} = getCurrentInstance()
			const res = await new proxy.$request(proxy.$urls.m().helpFlag_getDetail,{pageId}).modepost()
			if(res.status == 200){
				help_flag.value=true
				// callBack(res.data.data)
				callBack(true)
			}
		}
	},
}
export default common
